import { render, staticRenderFns } from "./indexBak.vue?vue&type=template&id=a0d16f2e&scoped=true&"
import script from "./indexBak.vue?vue&type=script&lang=js&"
export * from "./indexBak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d16f2e",
  null
  
)

export default component.exports